var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{ref:"inputRef",staticClass:"ci",style:({ textAlign: _vm.inputTextAlignments}),attrs:{"type":"text"}})
}
var staticRenderFns = []

export { render, staticRenderFns }